import { OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DashboardService } from '../../dashboard';
import { Data } from '../../helpers';
import { ErrorHandlerService } from '../../services';
import * as moment from 'moment';
import { EmbedVideoService } from 'ngx-embed-video';
var PreviewcourseComponent = /** @class */ (function () {
    function PreviewcourseComponent(embedService, data, dashboardService, router, route, errorHandlerService) {
        this.embedService = embedService;
        this.data = data;
        this.dashboardService = dashboardService;
        this.router = router;
        this.route = route;
        this.errorHandlerService = errorHandlerService;
        this.courseinfo = { user: {}, categories: [], displayStartDateOnly: Date, displayEndDateOnly: Date };
        this.timezone = Intl.DateTimeFormat().resolvedOptions().timeZone.toString();
        this.schedual = [];
        this.scheduleSummaryShort = "";
        this.scheduleSummaryLong = "";
        // Popup dialog settings
        this.showSpinner = false;
        this.showOnlyOverlay = false;
        this.showErrorModalDialog = false;
        this.showErrorMessages = [""];
        this.showErrorMessageTitle = "Error!";
        this.showErrorMessageWidthInPercentage = "20%";
        this.video_html = "";
        this.scheduleEndDate = "";
        this.subscriptions = [];
        this.PR = window["PR"];
        this.editSponsore = { price: 0, content: "", type: "silver" };
        this.editSponsoreShow = true;
        this.basictools = {
            items: ['Undo', 'Redo', '|',
                'Bold', 'Italic', 'Underline', 'LowerCase', 'UpperCase', '|',
                'Formats', 'Alignments', '|', 'OrderedList', 'UnorderedList']
        };
        if (this.data.storage == undefined) {
            this.router.navigate(['dashboard/createcourse']);
        }
        else {
            this.courseinfo = this.data.storage.coursepreview.coursedata;
        }
    }
    PreviewcourseComponent.prototype.editDisplay = function (edit) {
        if (edit) {
            return "block";
        }
        else {
            return "none";
        }
    };
    PreviewcourseComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.schedual = this.courseinfo.currentSchedule;
        console.log("The course info URL=" + this.courseinfo.url);
        console.log("course info=" + this.courseinfo.timeZone);
        var timezone = localStorage.getItem('timezone');
        var areEqual = false;
        if (localStorage.getItem('timezone')) {
            if (this.courseinfo.timeZone == timezone) {
                areEqual = true;
            }
            this.timezone = localStorage.getItem('timezone');
        }
        if (this.timezone) {
            this.timeZonechange(this.timezone, areEqual);
        }
        console.log("After changing timeZone");
        console.log(this.courseinfo);
        if (this.courseinfo.url) {
            try {
                this.video_html = this.embedService.embed(this.courseinfo.url);
                console.log("this.video_html" + this.video_html);
            }
            catch (err) {
                this.courseinfo.url = null;
            }
        }
        var repeateEveryCount = this.courseinfo.currentSchedule.repeateEveryCount;
        var repeatTypeStr = this.courseinfo.currentSchedule.repeatTypeStr;
        var selectedDaysOfWeekStr = [];
        if (this.courseinfo.currentSchedule.selectedDaysOfWeekStr) {
            selectedDaysOfWeekStr = this.courseinfo.currentSchedule.selectedDaysOfWeekStr;
        }
        if (repeatTypeStr == null || repeatTypeStr == 'None') {
            this.scheduleEndDate = this.courseinfo.displayStopDateOnlyConverted;
        }
        else {
            this.scheduleEndDate = moment(this.courseinfo.currentSchedule.endDate.split(" ")[0]).format('MM/DD/YYYY');
            if (this.timezone) {
                this.scheduleEndDate = this.convertTimezone(this.timezone, 'date', this.scheduleEndDate, areEqual);
            }
        }
        var s1 = this.dashboardService.retrieveCourseScheduleSummary(repeatTypeStr, repeateEveryCount, selectedDaysOfWeekStr).subscribe(function (data) {
            _this.scheduleSummaryShort = data.scheduleRepeatTypeShort;
            _this.scheduleSummaryLong = data.scheduleRepeatType;
        }, function (error) {
            console.log('Error occurred');
            console.log(error);
            _this.handleError(error);
        });
        this.subscriptions.push(s1);
        setTimeout(function () {
            _this.editSponsoreShow = false;
        }, 1000);
    };
    PreviewcourseComponent.prototype.timeZonechange = function (data, areEqual) {
        this.courseinfo.displayStartDateOnlyConverted = this.convertTimezone(data, 'date', this.courseinfo.displayStartDateOnly, areEqual);
        this.courseinfo.timeZoneConverted = data;
        this.courseinfo.displayStopDateOnlyConverted = this.convertTimezone(data, 'date', this.courseinfo.displayStopDateOnly, areEqual);
        this.courseinfo.startTimeConverted = this.convertTimezone(data, 'time', this.courseinfo.startTime.hour + ":" + this.courseinfo.startTime.minute, areEqual);
        this.courseinfo.endTimeConverted = this.convertTimezone(data, 'time', this.courseinfo.endTime.hour + ":" + this.courseinfo.endTime.minute, areEqual);
        localStorage.setItem('timezone', data);
    };
    PreviewcourseComponent.prototype.convertTimezone = function (timezone, type, datetime, areEqual) {
        if (type == 'date') {
            var setdate = moment(datetime, 'MM/DD/YYYY');
            console.log('before=' + setdate.format('MM/DD/YYYY'));
            if (areEqual == true) {
                console.log('time zone same - no need to convert');
                return setdate.format('MM/DD/YYYY');
            }
            var zz = setdate.tz(timezone).format('MM/DD/YYYY');
            console.log('after=' + zz);
            return zz;
        }
        else {
            var setdate = moment(datetime, 'HH:mm');
            console.log('before  time=' + setdate.format('HH:mm'));
            if (areEqual == true) {
                console.log('time zone same - no need to convert');
                return setdate.format('HH:mm');
            }
            var zz = setdate.tz(timezone).format('HH:mm');
            console.log('after time=' + zz);
            return zz;
        }
    };
    PreviewcourseComponent.prototype.createCourse = function () {
        var _this = this;
        this.showSpinner = true;
        // use a schedule to match the Server params.
        if (this.courseinfo.currentSchedule) {
            var endDate = this.courseinfo.currentSchedule.endDate == 'Invalid date' ? null : this.courseinfo.currentSchedule.endDate;
            var courseSchedule = {
                occurence: parseInt(this.courseinfo.currentSchedule.occurence),
                startDate: this.courseinfo.currentSchedule.startDate,
                endDate: endDate,
                selectedDaysOfWeekStr: this.courseinfo.currentSchedule.selectedDaysOfWeektempStr,
                repeatTypeStr: this.courseinfo.currentSchedule.repeattype,
                monthlyRepeatTypeStr: this.courseinfo.currentSchedule.monthlyRepeatTypeInputStr,
                endOfMeetingTypeStr: this.courseinfo.currentSchedule.endOfMeetingTypeInputStr,
                repeateEveryCount: this.courseinfo.currentSchedule.repeateEveryCount,
                isScheduleValid: this.courseinfo.currentSchedule.isScheduleValid
            };
            this.courseinfo.currentSchedule = courseSchedule;
        }
        console.log("Creating Course");
        console.log(this.courseinfo);
        var s2 = this.dashboardService.createCourse(this.courseinfo).subscribe(function (data) {
            _this.data.storage = null;
            _this.showSpinner = false;
            console.log(data);
            _this.router.navigate(['dashboard/courseaccount']);
        }, function (error) {
            _this.courseinfo.currentSchedule = _this.schedual;
            _this.showSpinner = false;
            console.log(error);
            _this.handleError(error);
        });
        this.subscriptions.push(s2);
    };
    PreviewcourseComponent.prototype.editSponsoreClick = function (sponsor) {
        this.editSponsore.price = sponsor.amount;
        this.editSponsore.content = sponsor.benefits;
        this.editSponsore.type = sponsor.sponsorshipLevel;
        this.editSponsoreShow = true;
    };
    PreviewcourseComponent.prototype.editSponsoreClose = function () {
        this.editSponsore.price = 0;
        this.editSponsore.content = "";
        this.editSponsore.type = "Silver";
        this.editSponsoreShow = false;
    };
    PreviewcourseComponent.prototype.editSponsoreSave = function () {
        var _this = this;
        this.courseinfo.sponsorshipLevels.forEach(function (element) {
            if (element.sponsorshipLevel == _this.editSponsore.type) {
                element.amount = _this.editSponsore.price;
                element.benefits = _this.editSponsore.content;
                _this.editSponsoreClose();
            }
        });
    };
    PreviewcourseComponent.prototype.editCourse = function () {
        this.courseinfo.currentSchedule = this.schedual;
        this.data.storage = {
            coursepreview: {
                coursedata: this.courseinfo
            }
        };
        this.router.navigate(['dashboard/createcourse']);
    };
    PreviewcourseComponent.prototype.closeCourse = function () {
        this.data.storage = {
            coursepreview: {
                coursedata: {}
            }
        };
        this.router.navigate(['dashboard/createcourse']);
    };
    PreviewcourseComponent.prototype.ngAfterViewChecked = function () {
        console.log('ngAfterViewChecked');
        this.PR.prettyPrint();
    };
    PreviewcourseComponent.prototype.handleError = function (error) {
        this.showSpinner = false;
        console.log("The error inside the Error Handler==>" + error);
        var url = error.url;
        console.log("The URL of the error==>" + error.url);
        if (url == undefined) {
            return;
        }
        console.log("Throwing the error now. Shall call the errorHandlerService throwError method");
        this.errorHandlerService.throwError(error);
    };
    PreviewcourseComponent.prototype.ngOnDestroy = function () {
        this.subscriptions.forEach(function (element) {
            element.unsubscribe();
        });
    };
    return PreviewcourseComponent;
}());
export { PreviewcourseComponent };
//# sourceMappingURL=previewcourse.component.js.map